import { Layout } from './src/Layout.ts';

customElements.define('dockit-layout', Layout);
